import React from 'react';
import GridRowContainer from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import HeaderCell from 'shared/lib/extendedComponents/grids/components/headerCell';
import {
  ExplorerEntityTypes,
  SortContentKey,
  SortContentOrder,
  sortContentMap,
} from 'entities/types';

export default function DesktopContentHeaderRow({
  onChange,
  value,
  supportTypes,
}: {
  supportTypes: ExplorerEntityTypes[];
  onChange?: (params: { key: SortContentKey; order: SortContentOrder }) => void;
  value?: { key: SortContentKey; order: SortContentOrder };
}) {
  return (
    <GridRowContainer className="FolderHeaderRow">
      <HeaderCell
        text={sortContentMap[SortContentKey.NAME].name}
        ascText="сортировка от Я до А"
        descText="сортировка от А до Я"
        isArrowReversed
        sort={
          onChange && value
            ? {
                currentValue: value,
                key: SortContentKey.NAME,
                onAscClick: () => {
                  onChange({
                    key: SortContentKey.NAME,
                    order: SortContentOrder.DESC,
                  });
                },
                onDescClick: () => {
                  onChange({
                    key: SortContentKey.NAME,
                    order: SortContentOrder.ASC,
                  });
                },
              }
            : undefined
        }
      ></HeaderCell>
      <HeaderCell
        text={sortContentMap[SortContentKey.LAST_CHANGE_DATE].name}
        ascText="сначала старые"
        descText="сначала новые"
        sort={
          onChange && value
            ? {
                currentValue: value,
                key: SortContentKey.LAST_CHANGE_DATE,
                onAscClick: () => {
                  onChange({
                    key: SortContentKey.LAST_CHANGE_DATE,
                    order: SortContentOrder.ASC,
                  });
                },
                onDescClick: () => {
                  onChange({
                    key: SortContentKey.LAST_CHANGE_DATE,
                    order: SortContentOrder.DESC,
                  });
                },
              }
            : undefined
        }
      ></HeaderCell>
      <HeaderCell
        text={sortContentMap[SortContentKey.EXTENSION].name}
        sort={
          onChange && value
            ? {
                currentValue: value,
                key: SortContentKey.EXTENSION,
                onAscClick: () => {
                  onChange({
                    key: SortContentKey.EXTENSION,
                    order: SortContentOrder.ASC,
                  });
                },
                onDescClick: () => {
                  onChange({
                    key: SortContentKey.EXTENSION,
                    order: SortContentOrder.DESC,
                  });
                },
              }
            : undefined
        }
      ></HeaderCell>
      {supportTypes.includes(ExplorerEntityTypes.FILE) ? (
        <HeaderCell
          text={sortContentMap[SortContentKey.SIZE].name}
          sort={
            onChange && value
              ? {
                  currentValue: value,
                  key: SortContentKey.SIZE,
                  onAscClick: () => {
                    onChange({
                      key: SortContentKey.SIZE,
                      order: SortContentOrder.ASC,
                    });
                  },
                  onDescClick: () => {
                    onChange({
                      key: SortContentKey.SIZE,
                      order: SortContentOrder.DESC,
                    });
                  },
                }
              : undefined
          }
        ></HeaderCell>
      ) : null}
      <span></span>
    </GridRowContainer>
  );
}
